import { AppRegistry } from "Apps/AppRegistry";
import { AddSquare24Filled, AddSquare24Regular, FluentIcon, MoreHorizontal24Filled, MoreHorizontal24Regular } from "@fluentui/react-icons";

// To do: redefine this interface based on real requirement
export interface AppLeftBarItem {
    displayName: string;
    description?: string;
    routeName?: string;
    subItems?: AppLeftBarItem[];
    regularIcon?: FluentIcon;
    filledIcon?: FluentIcon;
    isV1?: boolean;
    isNotLink?: boolean;
}

export const sideBarItems: AppLeftBarItem[] = [
    {
        displayName: "Home",
        description: AppRegistry.Dashboard.description,
        routeName: AppRegistry.Dashboard.path,
        regularIcon: AppRegistry.Dashboard.regularIcon,
        filledIcon: AppRegistry.Dashboard.filledIcon
    },
    {
        displayName: "Incidents Hub",
        description: AppRegistry.Incidents.description,
        regularIcon: AppRegistry.Incidents.regularIcon,
        filledIcon: AppRegistry.Incidents.filledIcon,
        routeName: AppRegistry.Incidents.path
    },
    {
        displayName: "Signal Health",
        description: AppRegistry.M365Health.description,
        regularIcon: AppRegistry.M365Health.regularIcon,
        filledIcon: AppRegistry.M365Health.filledIcon,
        routeName: AppRegistry.M365Health.path
    },
    {
        displayName: "Teams",
        description: AppRegistry.Teams.description,
        regularIcon: AppRegistry.Teams.regularIcon,
        filledIcon: AppRegistry.Teams.filledIcon,
        routeName: AppRegistry.Teams.path
    },
    {
        displayName: "Service Hub",
        description: AppRegistry.Service.description,
        regularIcon: AppRegistry.Service.regularIcon,
        filledIcon: AppRegistry.Service.filledIcon,
        routeName: AppRegistry.Service.path
    },
    {
        displayName: "Customer Hub",
        description: AppRegistry.CustomerHub.description,
        routeName: AppRegistry.CustomerHub.path,
        regularIcon: AppRegistry.CustomerHub.regularIcon,
        filledIcon: AppRegistry.CustomerHub.filledIcon
    },
    {
        displayName: "Sovereign Cloud Ops",
        description: AppRegistry.SovCloudOps.description,
        routeName: AppRegistry.SovCloudOps.path,
        regularIcon: AppRegistry.SovCloudOps.regularIcon,
        filledIcon: AppRegistry.SovCloudOps.filledIcon
    },
    {
        displayName: "Runtime Insights",
        description: AppRegistry.RuntimeInsights.description,
        routeName: AppRegistry.RuntimeInsights.path,
        regularIcon: AppRegistry.RuntimeInsights.regularIcon,
        filledIcon: AppRegistry.RuntimeInsights.filledIcon
    },
    {
        displayName: "Identity Hub",
        description: AppRegistry.IdentityHub.description,
        routeName: AppRegistry.IdentityHub.path,
        isV1: true,
        regularIcon: AppRegistry.IdentityHub.regularIcon,
        filledIcon: AppRegistry.IdentityHub.filledIcon
    },
    {
        displayName: "UMS",
        description: AppRegistry.UMS.description,
        routeName: AppRegistry.UMS.path,
        regularIcon: AppRegistry.UMS.regularIcon,
        filledIcon: AppRegistry.UMS.filledIcon
    },
    {
        displayName: "OpsGenie Copilot",
        description: AppRegistry.OpsGenie.description,
        routeName: AppRegistry.OpsGenie.path,
        regularIcon: AppRegistry.OpsGenie.regularIcon,
        filledIcon: AppRegistry.OpsGenie.filledIcon
    }
];

export const umsSideBarItems: AppLeftBarItem[] = [
    {
        displayName: "Home",
        routeName: AppRegistry.Dashboard.path,
        regularIcon: AppRegistry.Dashboard.regularIcon,
        filledIcon: AppRegistry.Dashboard.filledIcon
    },
    {
        displayName: "UMS",
        routeName: AppRegistry.UMS.path,
        regularIcon: AppRegistry.UMS.regularIcon,
        filledIcon: AppRegistry.UMS.filledIcon
    }
];

export const addAppItem: AppLeftBarItem = {
    displayName: "App Hub",
    description: AppRegistry.AppHub.description,
    regularIcon: AddSquare24Regular,
    filledIcon: AddSquare24Filled,
    routeName: AppRegistry.AppHub.path
};

export const overflowItem: AppLeftBarItem = {
    displayName: "More apps",
    regularIcon: MoreHorizontal24Regular,
    filledIcon: MoreHorizontal24Filled,
    isNotLink: true
};
